import React, {
  ReactNode,
} from 'react';
import {
  isEmptyString,
} from '@populateui/utils';

interface InfoRowProps {
  label: string;
  value?: string | ReactNode | null;
}

export default function InfoRow({ label, value }: InfoRowProps) {
  return (
    <div className="flex justify-between items-start text-xs gap-2">
      <span className="text-gray-600 font-medium whitespace-nowrap">
        {label}
        :
      </span>
      {isEmptyString(value) ? (
        <span className="text-gray-900 font-medium text-right ">—</span>
      ) : (
        <span className="text-gray-900 font-medium text-right">{value}</span>
      )}
    </div>
  );
}
